export default __webpack_public_path__ + "static/media/EEFF-2018-para-pantalla.f2340e8a.webp";